import configuration from '../../utilities/configuration';
import SubscribersStatDataModel from "../../models/statistics/subscribers/SubscribersStatDataModel";
import OneOffsStatDataModel from "../../models/statistics/one-offs/OneOffsStatDataModel";
import * as EffectUtility from "../../utilities/EffectUtility";
import SalesByProductStatDataModel from "../../models/statistics/salesByProduct/SalesByProductStatDataModel";
import SalesByUserStatDataModel from "../../models/statistics/salesByUser/SalesByUserStatDataModel";
import SingleIsinReportStatDataModel from "../../models/statistics/reports/SingleIsinReportStatDataModel";

export async function requestSubscribers(params) {
    const endpoint = configuration.apiServer + configuration.apiStatisticsSubscribersPath;
    return EffectUtility.getToModel(SubscribersStatDataModel, endpoint, params);
}

export async function requestOneOffss(params) {
    const endpoint = configuration.apiServer + configuration.apiStatisticsOneOffsPath;
    return EffectUtility.getToModel(OneOffsStatDataModel, endpoint, params);
}

export async function requestSalesByProduct(params) {
    const endpoint = configuration.apiServer + configuration.apiStatisticsSalesByProductPath;
    return EffectUtility.getToModel(SalesByProductStatDataModel, endpoint, params);
}

export async function requestSalesByUser(params) {
    const endpoint = configuration.apiServer + configuration.apiStatisticsSalesByUserPath;
    return EffectUtility.getToModel(SalesByUserStatDataModel, endpoint, params);
}

export async function requestSingleIsinReports(params) {
    const endpoint = configuration.apiServer + configuration.apiStatisticsReportsPath;
    return EffectUtility.getToModel(SingleIsinReportStatDataModel, endpoint, params);
}